import { Routes } from '../routes';

export function getDefaultMode(university: UniversityEntity): AppModules {
  const services = university?.samad;
  if (services?.nurture) {
    return 'nurture';
  }
  else if (services?.transport) {
    return 'transport';
  }
  else if (services?.help_desk) {
    return 'helpdesk';
  }
  else if (services?.sport) {
    return 'sport';
  }
  else if (services?.Clinics) {
    return 'health';
  }
  else if (services?.dormitory) {
    return 'dormitory';
  }
  else if (services?.faceEnrollment) {
    return 'face';
  }
}

export function getDefaultRoute(value: UniversityEntity | AppModules): string {
  const mode = typeof value === 'object' ? getDefaultMode(value) : value;
  switch (mode) {
    case 'nurture':
      return Routes.Food;
    case 'dormitory':
      return Routes.Dormitory;
    case 'face':
      return Routes.Face;
    case 'health':
      return Routes.Health;
    case 'survey':
      return Routes.Surveys;
    case 'sport':
      return Routes.Sport;
    case 'helpdesk':
      return Routes.Helpdesk;
    case 'transport':
      return Routes.Transport;
    default: '/';
  }
}

export const getTheme = (route: string) => {
  switch (true) {
    case route.startsWith(Routes.Sport):
      return 'sport';
    case route.startsWith(Routes.Dormitory):
      return 'dormitory';
    case route.startsWith(Routes.Helpdesk):
      return 'helpdesk';
    case route.startsWith(Routes.Health):
      return 'health';
    case route.startsWith(Routes.Transport):
      return 'transport';
    case route.startsWith(Routes.Face):
      return 'face';
    case route.startsWith(Routes.Surveys):
    case route.startsWith('/survey'):
      return 'survey';
    default:
      return 'nurture';
  }
};
